import { CONFIG } from '../config.js';
import { ChunkManager } from './streaming/ChunkManager.js';

/**
 * Walkable world container: streaming Matrix city.
 */
export class TestArena {
  constructor() {
    this.colliders = [];
    /** @type {ChunkManager | null} */
    this._manager = null;
  }

  build() {
    this._manager = new ChunkManager(CONFIG.city, CONFIG.streaming);
    this._manager.bootstrap();
    this.colliders = this._manager.colliders;
    const group = this._manager.group;
    group.name = 'TestArena';
    return group;
  }

  getSpawnPoint() {
    return this._manager?.getSpawnPoint() ?? { x: 0, y: 0, z: 0 };
  }

  getNavigationGraph() {
    return this._manager?.navigationGraph ?? null;
  }

  /**
   * @param {{ x: number; z: number }} [nearPosition]
   * @returns {import('./Colliders.js').BoxCollider[]}
   */
  getColliders(nearPosition) {
    if (!this._manager) return this.colliders;
    if (nearPosition) {
      return this._manager.getCollidersNear(nearPosition.x, nearPosition.z);
    }
    return this._manager.colliders;
  }

  getChunkManager() {
    return this._manager;
  }

  getEntranceRegistry() {
    return this._manager?.entranceRegistry ?? null;
  }

  /**
   * @param {number} deltaSeconds
   * @param {{ x: number; z: number }} [playerPosition]
   */
  update(deltaSeconds, playerPosition) {
    if (!this._manager || !playerPosition) return;
    this._manager.update(playerPosition.x, playerPosition.z, deltaSeconds);
  }

  getStreamingStats() {
    return (
      this._manager?.getStreamingStats() ?? {
        activeChunks: 0,
        buildingsLoaded: 0,
        chunkBounds: [],
      }
    );
  }

  dispose() {
    this._manager?.dispose();
    this._manager = null;
    this.colliders = [];
  }
}
